
var date = new Date()
import {mapState, mapGetters} from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import XyTabbar from '../src/components/views/common/xy-tabbar.vue'
import JsBridge from './tools/jsBridge'
import $ from 'jquery'
import router from './router'
import loginChecker from './tools/loginChecker'
import Vue from 'vue'
import channel from './tools/channel'
import DeviceInfo from './tools/deviceInfo'
import LocationHelper from './tools/locationHelper'
import statisticHelper from './tools/statisticalHelper'
import globalHelper from './tools/globalHelper'
import api from './api'
import { LOGIN_SUCCESS } from './store/mutation-types';
import { setTimeout } from 'timers';
export default {
name: 'app',
components: {
Loading,
XyTabbar,
XButton
},
data() {
return {
marketingPop: {}, // 营销弹窗内容
showMarketPop: false, // 营销弹窗显示标识
showMarket: true, // 是否点击了开屏广告并跳转
showDom: false, // 是否展示dom
showDownload: false
}
},
computed: mapState({
isLoading: state => state.loading.flag,
showTabbar: state => state.global.showTabbar
}),
methods: {

},
mounted() {
if (window.location.href.indexOf('isApp=true') >= 0) {
this.showDownload = true
}

window.sessionStorage.setItem('deviceStartNo', channel.setDeviceStartNo())

channel.parseChannel();
if (!globalHelper.isWeiXin() || (globalHelper.isWeiXin() && ('code' in globalHelper.urlParamesSplit(window.location.href)))) this.showDom = true
else this.showDom = false
var hash = window.location.hash
var backUrl = JSON.parse(window.localStorage.getItem('backUrl'))
if (globalHelper.isWeiXin()) {
window.sessionStorage.setItem('search', hash.split('?')[1] ? '?' + hash.split('?')[1] : '')
if (backUrl) {
this.$router.replace(backUrl)
} else {


let params = globalHelper.urlParamesSplit(window.location.href)
if (hash.indexOf('homePage') === -1 && hash.indexOf('wechat') === -1) {
let pathNameStr = hash.substring(0, hash.indexOf('?'))
let ShareParames = {
name: pathNameStr.substring(pathNameStr.lastIndexOf('/') + 1),
param: params
}
window.sessionStorage.setItem('shareUrl', JSON.stringify(ShareParames))
}

setTimeout(() => {
if (hash.indexOf('wechat') === -1) {
this.$router.replace({path: '/wechat'})
}
}, 500)
}
}

JsBridge.dealLaunchInfo((res) => {

if (res !== 'closeAd') this.showMarket = false
});

JsBridge.fetchUserInfo()



JsBridge.dealJPushInfo();

JsBridge.fetchDeviceInfoBak(() => {
if (window.location.href.indexOf('isIosCheck=true') === -1) window.sessionStorage.setItem('isApp', true)

if (this.$store.getters.isLogin) document.cookie = `JSESSIONID=${this.$store.getters.sessionId}; path=/;`
});

if (DeviceInfo.isWeixin()) {






}

$('input').blur(function () {
window.setTimeout(function () {
if ($(document).height() < $(window).height()) {
$(document).height($(window).height() + 'px');
}
}, 500);
});

if (!this.$store.getters.isLogin) {
this.$router.replace({name: 'quickLogin'})
}
}
}



// WEBPACK FOOTER //
// ./src/app.vue